import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=01bbf88f&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bbf88f')) {
      api.createRecord('01bbf88f', component.options)
    } else {
      api.reload('01bbf88f', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=01bbf88f&", function () {
      api.rerender('01bbf88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HMtB83I6YR7n/JS/comp/pricelist.vue"
export default component.exports